import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  BUTTON: `${cleanedFilename(__filename)}-button`,
};
